import * as React from 'react';
import RbLabel from '../../../bosch-react/components/label/RbLabel';
import { connect } from 'react-redux';
import '../../../core/scss/_customize.scss';
import { RootState } from '../../../store/store';
import { IStep } from '../types';
import { initSteps, updateStep, validateData } from '../actions';

interface UploadStepsProps {
    steps: IStep[],
    commonReport: any,
    uploadType?: string,
    initSteps: typeof initSteps,
    updateStep: typeof updateStep,
    validateData: typeof validateData
}

class UploadSteps extends React.Component<UploadStepsProps, any>{
    componentDidMount() {
        this.props.initSteps(this.props.commonReport.UploadType);
    }
    render() {
        let stepsArr: any[] = [];
        let selectedStep: IStep | undefined;
        this.props.steps.forEach((step, index) => {
            const lineClass = "step-line";
            let circleClass = "step-circle" + ((!!step.isSelected) ? " selected" : "");
            circleClass += (step.valid === undefined) ? " not-opened" : "";
            circleClass += (step.valid !== null) ? ((!!step.valid) ? " valid" : " invalid") : "";
            const iconClass = "step-icon rb-ic rb-ic-" + step.icon + ((step.valid === undefined) ? "-light-gray" : "-white");
            if (!!step.isSelected) {
                selectedStep = step;
            }
            stepsArr.push(
                <React.Fragment>
                    {/* Line */}
                    {(index !== 0) ? <div className={lineClass}><div className="line" /></div> : null}
                    {/* Step */}
                    <div className="upload-step" onClick={() => this.navigateToStep(step)}>
                        <div className="step-group">
                            <div className={circleClass}>
                                <span className={iconClass} />
                            </div>
                            <RbLabel className={"step-label" + circleClass.replace("step-circle", "")}>{step.label}</RbLabel>
                        </div>
                    </div>
                </React.Fragment>
            );
        });
        return (
            <div style={{ textAlign: "center" }}>
                <div className="upload-steps">
                    {/* Row containing only the dot/circle steps — kept as its
                        own flex row on mobile so the caption below isn't
                        pulled into the same row and flex-shrunk to nothing. */}
                    <div className="upload-steps-row">
                        {stepsArr.map((step, index) => <React.Fragment key={index}>{step}</React.Fragment>)}
                    </div>
                    {/* Mobile-only caption replacing the per-circle text labels, which
                        don't fit well once the stepper collapses into a single
                        compact row of small numbered dots: show the current step's
                        own big icon + label instead (same visual as the desktop
                        circle, just centered under the compact dot row). */}
                    {!!selectedStep &&
                        <div className="upload-steps-mobile-caption">
                            <div className="mobile-caption-circle">
                                <span className={"step-icon rb-ic rb-ic-" + selectedStep.icon + "-white"} />
                            </div>
                            <RbLabel className="mobile-caption-label">{selectedStep.label}</RbLabel>
                        </div>
                    }
                </div>
            </div>

        );
    }
    navigateToStep = (step: IStep) => {
        const currentStep = this.props.steps.find(step => !!step.isSelected)!;
        if (step.valid !== null && currentStep.label !== step.label) {
            this.props.validateData((result: boolean) => {
                if (result === true) {
                    currentStep.valid = true;
                    this.props.updateStep(currentStep);
                    if (step.valid === true) {
                        step.isSelected = true;
                        this.props.updateStep(step);
                    }
                }
                else { //set step to red
                    currentStep.valid! = false;
                    this.props.updateStep(currentStep);
                }

            })
        }

    }
}
const mapStateToProps = (state: RootState) => ({
    steps: state.upload.steps,
    commonReport: state.upload.commonReport
});
export default connect(mapStateToProps, { initSteps, updateStep, validateData })(UploadSteps);